import { IntegrationCatalogEntry } from "../types/integrationCatalog";

export interface RequiredIntegrationState {
  key: string;
  displayName: string;
  enabled: boolean;
  category: string | null;
  foundInCatalog: boolean;
}

const fallbackLabel = (key: string) =>
  key.replace(/[_-]/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());

export const isIntegrationEnabledForOrg = (
  entry?: IntegrationCatalogEntry | null,
) =>
  entry?.org_configured ??
  (entry?.org_enabled === true || entry?.org_enablement_status === "active");

export const resolveRequiredIntegrationStates = (
  requiredKeys: string[],
  catalogEntries: IntegrationCatalogEntry[],
): RequiredIntegrationState[] => {
  const seen = new Set<string>();
  return requiredKeys
    .filter((key) => {
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .map((key) => {
      const entry = catalogEntries.find((candidate) => candidate.key === key);
      return {
        key,
        displayName: entry?.display_name || fallbackLabel(key),
        enabled: isIntegrationEnabledForOrg(entry),
        category: entry?.category || null,
        foundInCatalog: Boolean(entry),
      };
    });
};

const formatDependencyList = (labels: string[]) => {
  if (labels.length === 0) return "";
  if (labels.length === 1) return labels[0];
  if (labels.length === 2) return `${labels[0]} and ${labels[1]}`;
  return `${labels.slice(0, -1).join(", ")}, and ${labels[labels.length - 1]}`;
};

export const buildDependencyBlockMessage = (
  missing: RequiredIntegrationState[],
) => {
  const labels = missing.map((item) => item.displayName);
  return `Configure ${formatDependencyList(labels)} before enabling this skill.`;
};
